import styled from 'styled-components';

import { Skeleton } from 'components';

export const SkeletonContainer = styled(Skeleton)`
  width: 100%;
  padding-top: 100%;
`;
